import urlUtils from 'util/url-utils'

function openFacebookShare(shareUrl: string, quote = null): void {
  // Facebook sharer only allows URL and some text to be passed
  const params = { u: shareUrl }
  if (quote) {
    params['quote'] = quote
  }
  const baseUrl = 'https://www.facebook.com/sharer/sharer.php'
  urlUtils.openWindow(`${baseUrl}?${urlUtils.buildQryString(params)}`)
}

function openPinterestShare(shareUrl: string, imageUrl: string, description: string): void {
  const baseUrl = 'https://www.pinterest.com/pin/create/button'
  const params = { url: shareUrl, media: imageUrl, description }
  urlUtils.openWindow(`${baseUrl}?${urlUtils.buildQryString(params)}`)
}

function openTwitterShare(shareUrl: string, text?: string): void {
  const params = { url: shareUrl }
  if (text) {
    params['text'] = text
  }
  const baseUrl = 'https://twitter.com/intent/tweet'
  urlUtils.openWindow(`${baseUrl}?${urlUtils.buildQryString(params)}`)
}

export default { openFacebookShare, openPinterestShare, openTwitterShare }
